import classes from './Notifications.module.css';

const Notifications = () => {
    return (
        <div className={classes.wrapper}>
        </div>
    )
}

export default Notifications;